import { render, staticRenderFns } from "./JointMasterList.vue?vue&type=template&id=2532feb8&scoped=true"
import script from "./JointMasterList.vue?vue&type=script&lang=js"
export * from "./JointMasterList.vue?vue&type=script&lang=js"
import style0 from "./JointMasterList.vue?vue&type=style&index=0&id=2532feb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532feb8",
  null
  
)

export default component.exports